export const invoiceTypes = [
  { id: 1, label: "Straight to Invoice" },
  { id: 2, label: "Credit Note" },
  { id: 3, label: "AFP Accrual" },
  { id: 4, label: "AFP Release" },
  { id: 5, label: "AFP Write-off" },
  { id: 6, label: "WIP Accrual" },
  { id: 7, label: "WIP Release" },
  { id: 8, label: "WIP Write-off" },
  { id: 9, label: "Prebill Accrual" },
  { id: 10, label: "Prebill Release" },
  { id: 11, label: "Prebill Write-off" }
];